import { ApiError } from '../api/client';
import { i18n } from '../i18n';

export interface ApiErrorDetail {
  code?: string;
  traceId?: string;
  message: string;
}

function t(path: string): string {
  return i18n.global.t(path) as string;
}

// 主行：中文可读文案。后端/前端错误码优先映射到 error.* 目录，否则按状态码兜底。
export function formatApiError(cause: unknown): string {
  if (cause instanceof SyntaxError) return t('error.SYNTAX_JSON');
  if (cause instanceof ApiError) {
    const key = `error.${cause.code}`;
    if (cause.code && cause.code !== 'REQUEST_FAILED' && i18n.global.te(key)) return i18n.global.t(key) as string;
    return cause.status === 0 || cause.status >= 500 || cause.status === 429 ? t('error.GENERIC_500') : t('error.GENERIC_400');
  }
  return cause instanceof Error ? cause.message : String(cause);
}

// 可展开诊断：保留错误码、追踪号与后端原始（英文）消息，便于排障。
export function apiErrorDetail(cause: unknown): ApiErrorDetail | null {
  if (cause instanceof ApiError) return { code: cause.code, traceId: cause.traceId, message: cause.message };
  if (cause instanceof Error) return { message: cause.message };
  return cause == null ? null : { message: String(cause) };
}
